import {Model} from '../base.model';

export class InvoiceServiceType extends Model {
  id: 'WarehouseWarehouse' | 'WarehouseDoors' | 'DoorsWarehouse' | 'DoorsDoors';
  name: string;
}
